import { HttpEventType } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { IcaRateImportModel } from 'src/app/models/imports/ica-rate-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { IcaRateService } from 'src/app/services/management/ica-rate.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-ica-rate',
  templateUrl: './import-ica-rate.component.html',
  styleUrl: './import-ica-rate.component.scss',
  standalone: false
})
export class ImportIcaRateComponent {

  private readonly icaRateService = inject(IcaRateService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  icaRateAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  icaRateImport: boolean = false;
  eventFile: any;
  errorIcaRate: number = 0;
  loadIcaRateModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  suscription: Subscription;
  visibleTxt: boolean = false;

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  attachFileImport() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.icaRateImport) {
      data.params = { reload: true };
      this.ref?.close(data);
    } else {
      data.params = { reload: false };
      this.ref?.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.icaRateService.downloadGuideImport().subscribe(data => {
      if (data.type === HttpEventType.Response) {
        const downloadedFile = new Blob([data.body!], { type: data.body!.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "GuiaTarifasICA.docx";
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.icaRateAlerts || this.icaRateAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.icaRateService.exportImportErrors(this.icaRateAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];
        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionTarifasICA_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importIcaRates() {
    this.icaRateAlerts = [];
    this.errorIcaRate = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<IcaRateImportModel>();
    let row: IcaRateImportModel;
    let counter: number = 1;

    let departmentCode: string, cityCode: string, conceptInvoicingCode: number,
      rate: number, minimumBase: number, code: string, saleAccount: string,
      saleDevolutionAccount: string, payAccountSelfWithholdingICA: string,
      devolutionAccountSelfWithholdingICA: string;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter++;
        let rowHasError = false;

        // A. Código Ciudad
        cityCode = element[0] as string;
        if (!cityCode) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de ciudad no es válido.`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        } else if (cityCode.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código de ciudad supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // B. Código Departamento
        departmentCode = element[1] as string;
        if (!departmentCode) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código de departamento no es válido.`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        } else if (departmentCode.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código de departamento supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // C. Código Concepto Facturación
        conceptInvoicingCode = parseInt(element[2] as string);
        if (isNaN(conceptInvoicingCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código de concepto de facturación no es válido.`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // D. Tasa
        rate = parseFloat(element[3] as string);
        if (isNaN(rate)) {
          if (element[3] !== null && element[3] !== undefined && element[3] !== '') {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. La tasa no es válida.`;
            this.icaRateAlerts.push(alert);
            rowHasError = true;
          }
          rate = 0;
        }

        // E. Base Mínima
        minimumBase = parseFloat(element[4] as string);
        if (isNaN(minimumBase)) {
          if (element[4] !== null && element[4] !== undefined && element[4] !== '') {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. La base mínima no es válida.`;
            this.icaRateAlerts.push(alert);
            rowHasError = true;
          }
          minimumBase = 0;
        }

        // F. Código
        code = element[5] as string;
        if (code != null && code.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El código supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // G. Cuenta Venta
        saleAccount = element[6] as string;
        if (saleAccount != null && saleAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. La cuenta de venta supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // H. Cuenta Devolución Venta
        saleDevolutionAccount = element[7] as string;
        if (saleDevolutionAccount != null && saleDevolutionAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. La cuenta de devolución venta supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // I. Cuenta Pago Autoretencion ICA
        payAccountSelfWithholdingICA = element[8] as string;
        if (payAccountSelfWithholdingICA != null && payAccountSelfWithholdingICA.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. La cuenta de pago autoretención ICA supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        // J. Cuenta Devolución Autoretencion ICA
        devolutionAccountSelfWithholdingICA = element[9] as string;
        if (devolutionAccountSelfWithholdingICA != null && devolutionAccountSelfWithholdingICA.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. La cuenta de devolución autoretención ICA supera el máximo de caracteres (10).`;
          this.icaRateAlerts.push(alert);
          rowHasError = true;
        }

        if (!rowHasError) {
          row = new IcaRateImportModel(
            counter, departmentCode, cityCode, conceptInvoicingCode, rate, minimumBase,
            code, saleAccount, saleDevolutionAccount, payAccountSelfWithholdingICA,
            devolutionAccountSelfWithholdingICA
          );
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (isOk && rowsImports.length > 0) {
        try {
          const response = await firstValueFrom(this.icaRateService.importIcaRates(rowsImports));
          this.loadIcaRateModel = response;
          this.icaRateAlerts = response?.alerts ?? [];
          this.errorIcaRate = response?.preInvoicingStateId;
          if (this.errorIcaRate === 1) {
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea.',
              'ERROR'
            );
          } else if (this.icaRateAlerts.length > 0) {
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con alertas, puede exportarlas si lo desea'
            );
          } else {
            this.visibleTxt = false;
            this.icaRateImport = true;
            this.toastHandlerService.showToast(
              'success',
              'La importación terminó exitosamente.'
            );
            this.close();
          }
          this.clearInputFile();
        } catch (error) {
          this.nameFile = 'Ningún archivo seleccionado.';
          console.error('Error al importar tarifas ICA.', error);
        }
      } else {
        this.errorIcaRate = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
      }
    });
  }
}
